import { Directive, inject } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalData } from '@shared/components/confirmation-modal/confirmation-modal.model';
import { filter, tap } from 'rxjs';
import { getConfirmationData } from '../../../shared/helpers/get-confirmation-data.helper';
import { ClerkCreateMinorFacadeService } from '../clerk-create-minor-facade.service';
import { RegisterMinorFormService } from '../register-minor-form.service';

@Directive({
  selector: '[appHandleClerkCreateMinorSubmit]',
  host: { '(ngSubmit)': 'handleClick()' },
})
export class HandleClerkCreateMinorSubmitDirective {
  private readonly _formService = inject(RegisterMinorFormService);
  private readonly _dialog = inject(Dialog);
  private readonly _submitFacade = inject(ClerkCreateMinorFacadeService);
  private readonly _dialogRef = inject(DialogRef);

  private readonly _form = this._formService.form;

  private readonly _confirmationData: ConfirmationModalData =
    getConfirmationData(`Minor's Estates`);

  protected handleClick() {
    const isLinkingUser = this._form.controls.userId.value !== 0;
    if (!isLinkingUser) {
      this._dialogRef.close();
      this._submitFacade.submitApplication();
      return;
    }

    this._dialogRef.close();
    const dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: this._confirmationData,
    });

    dialogRef.closed
      .pipe(
        filter((confirmed) => !!confirmed),
        tap(() => {
          this._submitFacade.submitApplication();
        }),
      )
      .subscribe();
  }
}
